module.exports = __webpack_public_path__ + "assets/img/eebd076005f42a8450e0ba1ba556e7d8.svg";